export const packageList = [
  {
    name: 'qms',
    activeRule: ['qms'],
    preload: true,
  },
  {
    name: 'bids',
    activeRule: ['bids'],
  },
  {
    name: 'ims_supplier',
    activeRule: ['imsSupplier'],
  },
  {
    name: 'ims',
    activeRule: ['ims'],
    preload: true,
  },
  {
    name: 'ims_monitor',
    activeRule: ['ims-monitor'],
  },
  {
    name: 'ims_site',
    activeRule: ['ims-site'],
  },
]

export const remoteModuleConfig = {
  dev: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site'],
  stg: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site'],
  uat: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site'],
  prd: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/ims/index.js